"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.focusSource = void 0;
var focus_source_1 = __importDefault(require("ally.js/style/focus-source"));
var focusSource = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return focus_source_1.default.apply(void 0, args);
};
exports.focusSource = focusSource;
//# sourceMappingURL=focus-source.js.map